<template>
  <div>
    <Header
      class="yh-header"
      active="/product"
      show-sub
      :sub-menu="source ? subMenuCategory : subMenu"
      :product-value="productValue"
    >
      <template #left>
        <ImageAndName
          :image="util.getImageUrl(util.getHead(util.string2Array(get.images)), '48x48')"
          :name="source ? get.categoryName : get.name"
          :code="source ? get.categoryCode : get.code"
        />
      </template>
      <template #right>
        <Feedback
          target-name="数据看板"
          :target-id="$route.params.id"
        />
        <Favourite
          target-name="product"
          :target-id="$route.params.id"
          :purchase-level="0"
        />
      </template>
    </Header>
    <div style="height: 130px" />

    <ScSaleCommodity
      v-if="get.categoryCode || get.code"
      :code="source ? '' : get.code"
      :category-code="source ? get.categoryCode : ''"
    />
    <div class="split" />
    <ScSupplier
      v-if="get.categoryCode || get.code"
      :code="source ? '' : get.code"
      :category-code="source ? get.categoryCode : ''"
    />
    <div class="split" />
    <ScSaleRanking
      v-if="get.categoryCode || get.code"
      :code="source ? '' : get.code"
      :category-code="source ? get.categoryCode : ''"
    />

    <div style="min-height: 70px" />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Favourite from '@/components/Favourite.vue'
import Feedback from '@/components/Feedback'
import ImageAndName from '@/components/ImageAndName.vue'

import ScSaleCommodity from '@/components/dashboard/ScSaleCommodity'
import ScSupplier from '@/components/dashboard/ScSupplier'
import ScSaleRanking from '@/components/dashboard/ScSaleRanking'

export default {
  name: 'ProductDashboard',
  components: {
    Header,
    Favourite,
    ImageAndName,
    Feedback,

    ScSaleCommodity,
    ScSupplier,
    ScSaleRanking
  },
  data() {
    return {
      subMenu: [
        {
          name: '商品百科',
          path: `/product/baike/${this.$route.params.id}`,
          active: false
        },
        {
          name: '供应链信息',
          path: `/product/chain/${this.$route.params.id}`,
          active: false
        },
        {
          name: '数据看板',
          path: `/product/dashboard/${this.$route.params.id}`,
          active: true
        }
      ],
      subMenuCategory: [
        {
          name: '数据看板',
          disabled: true,
          active: true
        }
      ],
      source: this.$route.query.source || '', // 来源 'category':小类   '': 商品
      productValue: this.util.getVariantSession('tagId')
    }
  },
  computed: {
    get() {
      return this.$store.state.product.productBase.get
    }
  },
  async created() {
    // 获取商品信息
    await this.$store.dispatch('productBasePage', {
      packageName: 'product',
      className: 'productBase',
      methodName: 'get',
      params: {
        id: this.$route.params.id
      }
    })

    this.ajax.doPost({
      packageName: 'user',
      className: 'userAnalysis',
      methodName: 'create',
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: '商品百科-数据看板',
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    })
  },
  methods: {}
}
</script>

<style lang="scss">
.split {
  width: 100%;
  height: 10px;
  background: rgba(244, 244, 244, 1);
}
</style>
